module.exports = __webpack_public_path__ + "img/empty.b82fa75a.png";